module.exports = __webpack_public_path__ + "static/media/applogo-wtext.78240662.png";